module.exports = __webpack_public_path__ + "img/insta.8a84bb49.svg";